"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bodyPreviewFromDraftHistory = exports.bodyPreviewFromRevisionFields = exports.getRecoverRevisionFields = exports.pickArchivePreviewRevisionIndex = exports.getArchiveStorageKey = exports.clearDraftHistory = exports.saveDraftHistory = exports.appendDraftRevision = exports.loadDraftHistory = exports.summarizeDraftChanges = exports.formatFieldChangeSummary = exports.summarizeTextDiff = exports.tokenizeForDiff = exports.valuesEqual = exports.bodyDiffViewLines = exports.bodyDiffViewLinesToMono = exports.formatBodyDiffViewLines = exports.outlineLineContentKey = exports.stripOutlineFoldMarkers = exports.listChangedFieldLabels = exports.hasEditsFromBaseline = exports.findRestoreRevisionIndex = exports.revisionsEqual = exports.applyDraftFields = exports.collectDraftFields = exports.isMeaningfulDraftValue = exports.deserializeDraftValue = exports.diffSerializedDraftFields = exports.checksumsEqual = exports.draftChecksum = exports.draftSnapshot = exports.serializeDraftValue = exports.getLocalDraftStorageKey = exports.getDraftFieldNames = exports.toDraftChangeDisplayItems = exports.classifyDraftDiff = exports.displayDraftChangeSummary = exports.FIELD_LABELS = exports.RISKY_REPLY_FIELDS = exports.RISKY_EDIT_FIELDS = exports.REPLY_DRAFT_FIELDS = exports.EDIT_DRAFT_FIELDS = exports.LOCAL_DRAFT_ARCHIVE_MAX_AGE_MS = exports.LOCAL_DRAFT_ARCHIVE_MAX_ENTRIES = exports.LOCAL_DRAFT_MAX_REVISIONS = exports.LOCAL_DRAFT_RETENTION_DAYS = exports.LOCAL_DRAFT_MAX_AGE_MS = exports.LOCAL_DRAFT_DEBOUNCE_MS = exports.LOCAL_DRAFT_ARCHIVE_PREFIX = exports.LOCAL_DRAFT_STORAGE_PREFIX = void 0;
exports.applyUndoSnapshot = exports.captureUndoSnapshot = exports.buildRestorePreview = exports.getLatestRevision = exports.discardArchivedDraft = exports.archiveCurrentFormBeforeRecover = exports.restoreArchivedDraftToActive = exports.archiveAndClearDraftHistory = exports.archiveDraftHistory = exports.archiveFormSnapshot = exports.findArchivedDraftRecord = exports.draftFieldsDiffer = exports.countArchivedDrafts = exports.loadArchivedDrafts = exports.pruneArchivedDrafts = exports.listArchivedDraftSummaries = exports.formMatchesRevisionFields = exports.bodyDiffPreview = exports.firstBodyLineDiffHunk = exports.uniqueBodyLinesPreview = exports.uniqueBodyLines = exports.normalizeBodyLines = void 0;
exports.LOCAL_DRAFT_STORAGE_PREFIX = 'audroam.resultRowDraft';
exports.LOCAL_DRAFT_ARCHIVE_PREFIX = 'audroam.resultRowDraftArchive';
/** Persist shortly after edits so reload/crash loses less work (was 700ms). */
exports.LOCAL_DRAFT_DEBOUNCE_MS = 350;
exports.LOCAL_DRAFT_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
exports.LOCAL_DRAFT_RETENTION_DAYS = Math.round(exports.LOCAL_DRAFT_MAX_AGE_MS / (24 * 60 * 60 * 1000));
exports.LOCAL_DRAFT_MAX_REVISIONS = 25;
exports.LOCAL_DRAFT_ARCHIVE_MAX_ENTRIES = 80;
exports.LOCAL_DRAFT_ARCHIVE_MAX_AGE_MS = exports.LOCAL_DRAFT_MAX_AGE_MS;
exports.EDIT_DRAFT_FIELDS = [
    'pnBody',
    'pnCustomTimeUTC',
    'pnCompletedUTC',
    'pnCompletedPersonPK',
    'pnSchedule',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnItemCode',
    'pnInvoiceNote',
    'pnValue',
    'pnValueUnit',
    'pnUserRoamHint',
    'pnUserRoamPoint',
    'pnUserRoamGeoLat',
    'pnUserRoamGeoLon',
    'pnAssetTag',
    'pnAssetTagAux',
    'pnAssetAccount',
    'pnAssetRealm',
    'pnAccount',
    'pnUserRealm',
    'pnShareLevel',
    'pnParentFK',
    'pnParentAddFK',
];
exports.REPLY_DRAFT_FIELDS = [
    'pnBody',
    'pnTaskGroup',
    'pnTopicGroup',
    'pnTopicDetail',
    'pnItemCode',
    'pnValue',
    'pnValueUnit',
    'ReplyAsPeer',
    'ReplyAsSchedule',
    'ReplyAsAssignedTo',
    'doneCheck',
];
/** Fields where clearing or replacing can lose billing/time data. */
exports.RISKY_EDIT_FIELDS = new Set([
    'pnCompletedUTC',
    'pnCustomTimeUTC',
    'pnValue',
    'pnValueUnit',
    'pnInvoiceNote',
    'pnItemCode',
    'pnCompletedPersonPK',
]);
exports.RISKY_REPLY_FIELDS = new Set(['pnValue', 'pnValueUnit', 'pnItemCode']);
exports.FIELD_LABELS = {
    pnBody: 'body',
    pnCustomTimeUTC: 'start time',
    pnCompletedUTC: 'finish time',
    pnCompletedPersonPK: 'completed by',
    pnSchedule: 'schedule',
    pnTaskGroup: 'task group',
    pnTopicGroup: 'topic group',
    pnTopicDetail: 'topic detail',
    pnItemCode: 'item code',
    pnInvoiceNote: 'invoice note',
    pnValue: 'qty/duration',
    pnValueUnit: 'units',
};
/** Turn escaped diff text (\\n) into displayable pre-wrap content. */
function displayDraftChangeSummary(changeSummary) {
    return changeSummary.replace(/\\n/g, '\n');
}
exports.displayDraftChangeSummary = displayDraftChangeSummary;
function classifyDraftDiff(changeSummary) {
    var trimmed = changeSummary.trim();
    // Multi-hunk git-style summaries may start with context (… word) then -/+ hunks
    var hasAdd = /(^|\s)\+/.test(trimmed);
    // Avoid treating ISO dates / negative numbers as deletions
    var hasDel = /(^|\s)-(?!\d)/.test(trimmed);
    if (hasAdd && hasDel) {
        return 'mixed';
    }
    if (hasAdd) {
        return 'add';
    }
    if (hasDel) {
        return 'del';
    }
    if (trimmed.includes('→')) {
        return 'transition';
    }
    return 'neutral';
}
exports.classifyDraftDiff = classifyDraftDiff;
function toDraftChangeDisplayItems(changes) {
    return changes.map(function (change) { return ({
        field: change.field,
        label: change.label,
        displaySummary: displayDraftChangeSummary(change.changeSummary),
        diffKind: classifyDraftDiff(change.changeSummary),
        risky: change.risky,
    }); });
}
exports.toDraftChangeDisplayItems = toDraftChangeDisplayItems;
function getDraftFieldNames(mode) {
    return mode === 'edit' ? exports.EDIT_DRAFT_FIELDS : exports.REPLY_DRAFT_FIELDS;
}
exports.getDraftFieldNames = getDraftFieldNames;
function getLocalDraftStorageKey(personId, mode, rowId) {
    var pid = personId !== null && personId !== void 0 ? personId : 'anon';
    var rid = rowId !== undefined && rowId !== null ? rowId : 'unknown';
    return "".concat(exports.LOCAL_DRAFT_STORAGE_PREFIX, ":").concat(pid, ":").concat(mode, ":").concat(rid);
}
exports.getLocalDraftStorageKey = getLocalDraftStorageKey;
function serializeDraftValue(value) {
    if (value instanceof Date) {
        return value.toISOString();
    }
    if (typeof value === 'number' && isNaN(value)) {
        return null;
    }
    if (value === undefined) {
        return null;
    }
    return value;
}
exports.serializeDraftValue = serializeDraftValue;
/** Canonical serialized form of tracked draft fields (stable key order). */
function draftSnapshot(source, mode) {
    return JSON.stringify(collectDraftFields(source, mode));
}
exports.draftSnapshot = draftSnapshot;
/** Fast checksum for watch/compare — same input always yields same hash. */
function draftChecksum(source, mode) {
    var snapshot = draftSnapshot(source, mode);
    var hash = 0x811c9dc5;
    for (var i = 0; i < snapshot.length; i++) {
        hash ^= snapshot.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    return (hash >>> 0).toString(16).padStart(8, '0');
}
exports.draftChecksum = draftChecksum;
function checksumsEqual(a, b, mode) {
    return draftChecksum(a, mode) === draftChecksum(b, mode);
}
exports.checksumsEqual = checksumsEqual;
/** Field-level diff between two serialized draft snapshots (baseline vs saved revision). */
function diffSerializedDraftFields(fromFields, toFields, mode) {
    var changes = [];
    getDraftFieldNames(mode).forEach(function (field) {
        if (valuesEqual(fromFields[field], toFields[field], field)) {
            return;
        }
        changes.push({
            field: field,
            label: exports.FIELD_LABELS[field] || field,
            currentDisplay: formatDisplayValue(field, fromFields[field]),
            draftDisplay: formatDisplayValue(field, toFields[field]),
            changeSummary: formatFieldChangeSummary(field, fromFields[field], toFields[field]),
            risky: isRiskyChange(field, mode, fromFields[field], toFields[field]),
        });
    });
    return changes;
}
exports.diffSerializedDraftFields = diffSerializedDraftFields;
function deserializeDraftValue(fieldName, value) {
    if ((fieldName === 'pnCustomTimeUTC' || fieldName === 'pnCompletedUTC') && value) {
        var parsedDate = new Date(value);
        if (!isNaN(parsedDate.getTime())) {
            return parsedDate;
        }
        return null;
    }
    return value;
}
exports.deserializeDraftValue = deserializeDraftValue;
function isMeaningfulDraftValue(value) {
    if (value === undefined || value === null || value === '') {
        return false;
    }
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'number') {
        return !isNaN(value);
    }
    return true;
}
exports.isMeaningfulDraftValue = isMeaningfulDraftValue;
function collectDraftFields(source, mode) {
    var fields = {};
    getDraftFieldNames(mode).forEach(function (fieldName) {
        fields[fieldName] = serializeDraftValue(source ? source[fieldName] : undefined);
    });
    return fields;
}
exports.collectDraftFields = collectDraftFields;
function applyDraftFields(target, fields) {
    if (!target || !fields) {
        return;
    }
    Object.keys(fields).forEach(function (fieldName) {
        target[fieldName] = deserializeDraftValue(fieldName, fields[fieldName]);
    });
}
exports.applyDraftFields = applyDraftFields;
function revisionsEqual(a, b, mode) {
    return getDraftFieldNames(mode).every(function (field) { return valuesEqual(a[field], b[field], field); });
}
exports.revisionsEqual = revisionsEqual;
/** First revision that differs from the open form; falls back to 0 when all match. */
function findRestoreRevisionIndex(history, current) {
    for (var i = 0; i < history.revisions.length; i++) {
        if (!revisionsEqual(history.revisions[i].fields, collectDraftFields(current, history.mode), history.mode)) {
            return i;
        }
    }
    return 0;
}
exports.findRestoreRevisionIndex = findRestoreRevisionIndex;
/** True when serialized fields differ from the form state at edit/reply open. */
function hasEditsFromBaseline(baselineFields, newFields, mode) {
    return !revisionsEqual(baselineFields, newFields, mode);
}
exports.hasEditsFromBaseline = hasEditsFromBaseline;
/** Human-readable labels for fields that differ between two snapshots. */
function listChangedFieldLabels(fromFields, toFields, mode) {
    var labels = [];
    getDraftFieldNames(mode).forEach(function (field) {
        if (!valuesEqual(fromFields[field], toFields[field], field)) {
            labels.push(exports.FIELD_LABELS[field] || field);
        }
    });
    return labels;
}
exports.listChangedFieldLabels = listChangedFieldLabels;
/**
 * Strip outline fold markers so expand/collapse is not a "change".
 * Matches outlineBody fold: trailing " (+)" with optional spaces.
 */
function stripOutlineFoldMarkers(text) {
    return String(text || '')
        .replace(/\r\n?/g, '\n')
        .replace(/\s*\(\+\)\s*$/gm, '')
        .replace(/[ \t]+$/gm, '');
}
exports.stripOutlineFoldMarkers = stripOutlineFoldMarkers;
/** Content key for a body line (fold-insensitive). */
function outlineLineContentKey(line) {
    return stripOutlineFoldMarkers(line);
}
exports.outlineLineContentKey = outlineLineContentKey;
function formatBodyDiffViewLines(onlyFrom, onlyTo, maxLines) {
    if (maxLines === void 0) { maxLines = 12; }
    var out = [];
    out.push({
        kind: 'meta',
        text: "Only in left \u2212".concat(onlyFrom.length, " \u00B7 only in right +").concat(onlyTo.length),
        mono: "only \u2212".concat(onlyFrom.length, " +").concat(onlyTo.length),
    });
    var n = 0;
    for (var _i = 0, onlyFrom_1 = onlyFrom; _i < onlyFrom_1.length; _i++) {
        var line = onlyFrom_1[_i];
        if (n >= maxLines) {
            out.push({ kind: 'meta', text: '…', mono: '…' });
            break;
        }
        var text = stripOutlineFoldMarkers(line);
        out.push({ kind: 'del', text: text, mono: "\u2212| ".concat(text) });
        n += 1;
    }
    for (var _a = 0, onlyTo_1 = onlyTo; _a < onlyTo_1.length; _a++) {
        var line = onlyTo_1[_a];
        if (n >= maxLines) {
            out.push({ kind: 'meta', text: '…', mono: '…' });
            break;
        }
        var text = stripOutlineFoldMarkers(line);
        out.push({ kind: 'add', text: text, mono: "+| ".concat(text) });
        n += 1;
    }
    return out;
}
exports.formatBodyDiffViewLines = formatBodyDiffViewLines;
function bodyDiffViewLinesToMono(lines) {
    return lines.map(function (l) { return l.mono; }).join('\n');
}
exports.bodyDiffViewLinesToMono = bodyDiffViewLinesToMono;
/** Structured lines for colored archive UI. */
function bodyDiffViewLines(fromBody, toBody, maxLines) {
    if (maxLines === void 0) { maxLines = 12; }
    if (stripOutlineFoldMarkers(String(fromBody !== null && fromBody !== void 0 ? fromBody : '')) ===
        stripOutlineFoldMarkers(String(toBody !== null && toBody !== void 0 ? toBody : ''))) {
        return [{ kind: 'meta', text: 'No content change (fold/blank only)', mono: '(identical body)' }];
    }
    var _a = uniqueBodyLines(fromBody, toBody), onlyFrom = _a.onlyFrom, onlyTo = _a.onlyTo;
    if (onlyFrom.length || onlyTo.length) {
        return formatBodyDiffViewLines(onlyFrom, onlyTo, maxLines);
    }
    return [
        {
            kind: 'meta',
            text: 'Same lines, different order (reorder only)',
            mono: '(reorder only — same line content)',
        },
    ];
}
exports.bodyDiffViewLines = bodyDiffViewLines;
function valuesEqual(a, b, fieldName) {
    if (fieldName === 'pnCustomTimeUTC' || fieldName === 'pnCompletedUTC') {
        var aTime = a instanceof Date ? a.getTime() : a ? new Date(a).getTime() : NaN;
        var bTime = b instanceof Date ? b.getTime() : b ? new Date(b).getTime() : NaN;
        if (isNaN(aTime) && isNaN(bTime)) {
            return true;
        }
        return aTime === bTime;
    }
    if (fieldName === 'pnBody') {
        // Fold-only outline toggles must not count as draft/archive differences
        return stripOutlineFoldMarkers(String(a !== null && a !== void 0 ? a : '')) === stripOutlineFoldMarkers(String(b !== null && b !== void 0 ? b : ''));
    }
    return JSON.stringify(serializeDraftValue(a)) === JSON.stringify(serializeDraftValue(b));
}
exports.valuesEqual = valuesEqual;
var TEXT_DIFF_FIELDS = new Set(['pnBody', 'pnInvoiceNote']);
/** Word/whitespace token cap for LCS multi-hunk diffs (fall back if larger). */
var TEXT_DIFF_TOKEN_LIMIT = 400;
/** Equal tokens kept as context on each side of a change (git-style). Keep tiny — long context looks like "no change". */
var TEXT_DIFF_CONTEXT_TOKENS = 1;
/** Max total escaped length of a formatted text diff summary. */
var TEXT_DIFF_SUMMARY_MAX = 280;
function escapeDiffText(text) {
    return text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').replace(/\n/g, '\\n');
}
function formatDiffChunk(text, maxLen) {
    if (maxLen === void 0) { maxLen = 120; }
    var escaped = escapeDiffText(text);
    if (escaped.length <= maxLen) {
        return escaped;
    }
    return "".concat(escaped.slice(0, maxLen), "\u2026 (+").concat(escaped.length - maxLen, " more)");
}
/** Split into words and whitespace so multi-site edits stay as separate hunks. */
function tokenizeForDiff(text) {
    var normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    return normalized.match(/\S+|\s+/g) || [];
}
exports.tokenizeForDiff = tokenizeForDiff;
/** Token-level LCS walk — surfaces multiple independent edits like a mini git diff. */
function diffTokensLcs(a, b) {
    var n = a.length;
    var m = b.length;
    // dp[i][j] = LCS length of a[i..] and b[j..]
    var dp = Array.from({ length: n + 1 }, function () { return new Array(m + 1).fill(0); });
    for (var i_1 = n - 1; i_1 >= 0; i_1--) {
        for (var j_1 = m - 1; j_1 >= 0; j_1--) {
            if (a[i_1] === b[j_1]) {
                dp[i_1][j_1] = dp[i_1 + 1][j_1 + 1] + 1;
            }
            else {
                dp[i_1][j_1] = Math.max(dp[i_1 + 1][j_1], dp[i_1][j_1 + 1]);
            }
        }
    }
    var ops = [];
    var i = 0;
    var j = 0;
    while (i < n && j < m) {
        if (a[i] === b[j]) {
            ops.push({ kind: 'eq', text: a[i] });
            i++;
            j++;
        }
        else if (dp[i + 1][j] >= dp[i][j + 1]) {
            ops.push({ kind: 'del', text: a[i] });
            i++;
        }
        else {
            ops.push({ kind: 'add', text: b[j] });
            j++;
        }
    }
    while (i < n) {
        ops.push({ kind: 'del', text: a[i++] });
    }
    while (j < m) {
        ops.push({ kind: 'add', text: b[j++] });
    }
    return ops;
}
/** Merge adjacent ops of the same kind (keeps whitespace with neighboring words of same kind). */
function mergeDiffOps(ops) {
    var merged = [];
    for (var _i = 0, ops_1 = ops; _i < ops_1.length; _i++) {
        var op = ops_1[_i];
        var last = merged[merged.length - 1];
        if (last && last.kind === op.kind) {
            last.text += op.text;
        }
        else {
            merged.push({ kind: op.kind, text: op.text });
        }
    }
    return merged;
}
/**
 * Collapse long equal runs to … with a little context, so two word edits in a
 * long paragraph show as two small -/+ hunks instead of one huge block.
 */
function formatMultiHunkDiff(ops) {
    var merged = mergeDiffOps(ops);
    if (!merged.some(function (op) { return op.kind !== 'eq'; })) {
        return '(unchanged)';
    }
    // Mark which eq runs are "near" a change (keep full), others collapse mid-run.
    var nearChange = merged.map(function () { return false; });
    for (var i = 0; i < merged.length; i++) {
        if (merged[i].kind !== 'eq') {
            if (i > 0 && merged[i - 1].kind === 'eq') {
                nearChange[i - 1] = true;
            }
            if (i + 1 < merged.length && merged[i + 1].kind === 'eq') {
                nearChange[i + 1] = true;
            }
        }
    }
    var parts = [];
    for (var i = 0; i < merged.length; i++) {
        var op = merged[i];
        if (op.kind === 'eq') {
            var tokens = tokenizeForDiff(op.text);
            if (!nearChange[i]) {
                // Middle equal span between two change sites — ellipsis only
                if (tokens.length > TEXT_DIFF_CONTEXT_TOKENS * 2) {
                    parts.push('…');
                }
                else if (tokens.length) {
                    parts.push(escapeDiffText(op.text));
                }
                continue;
            }
            // Context next to a change: keep last/first few tokens
            if (tokens.length <= TEXT_DIFF_CONTEXT_TOKENS * 2) {
                parts.push(escapeDiffText(op.text));
            }
            else {
                var prevIsChange = i > 0 && merged[i - 1].kind !== 'eq';
                var nextIsChange = i + 1 < merged.length && merged[i + 1].kind !== 'eq';
                if (prevIsChange && nextIsChange) {
                    // eq sandwiched between two edits — small ends + …
                    var head = tokens.slice(0, TEXT_DIFF_CONTEXT_TOKENS).join('');
                    var tail = tokens.slice(-TEXT_DIFF_CONTEXT_TOKENS).join('');
                    parts.push(escapeDiffText(head) + '…' + escapeDiffText(tail));
                }
                else if (nextIsChange) {
                    // leading context before a change
                    var tail = tokens.slice(-TEXT_DIFF_CONTEXT_TOKENS).join('');
                    var headExtra = tokens.length > TEXT_DIFF_CONTEXT_TOKENS;
                    parts.push((headExtra ? '…' : '') + escapeDiffText(tail));
                }
                else {
                    // trailing context after a change
                    var head = tokens.slice(0, TEXT_DIFF_CONTEXT_TOKENS).join('');
                    var tailExtra = tokens.length > TEXT_DIFF_CONTEXT_TOKENS;
                    parts.push(escapeDiffText(head) + (tailExtra ? '…' : ''));
                }
            }
        }
        else if (op.kind === 'del') {
            parts.push("-".concat(formatDiffChunk(op.text, 80)));
        }
        else {
            parts.push("+".concat(formatDiffChunk(op.text, 80)));
        }
    }
    var summary = parts.join(' ').replace(/\s+/g, ' ').trim();
    // Tidy spaces around ellipsis / signs
    summary = summary
        .replace(/\s*…\s*/g, ' … ')
        .replace(/\s+/g, ' ')
        .trim();
    if (summary.length > TEXT_DIFF_SUMMARY_MAX) {
        return "".concat(summary.slice(0, TEXT_DIFF_SUMMARY_MAX), "\u2026 (+").concat(summary.length - TEXT_DIFF_SUMMARY_MAX, " more)");
    }
    return summary || '(changed)';
}
/** Single middle-block character diff (legacy fallback for huge texts). */
function summarizeTextDiffPrefixSuffix(from, to) {
    var start = 0;
    while (start < from.length && start < to.length && from[start] === to[start]) {
        start++;
    }
    var endFrom = from.length;
    var endTo = to.length;
    while (endFrom > start && endTo > start && from[endFrom - 1] === to[endTo - 1]) {
        endFrom--;
        endTo--;
    }
    var removed = from.slice(start, endFrom);
    var added = to.slice(start, endTo);
    var parts = [];
    if (removed) {
        parts.push("-".concat(formatDiffChunk(removed)));
    }
    if (added) {
        parts.push("+".concat(formatDiffChunk(added)));
    }
    return parts.join(' ') || '(changed)';
}
/**
 * Git-like string/word diff for draft previews.
 * Multiple independent edits produce separate -/+ hunks with ellipsis context,
 * instead of one large remove/add of everything between the first and last change.
 */
function summarizeTextDiff(from, to) {
    // Ignore fold markers so outline expand/collapse is not noise
    var fromN = stripOutlineFoldMarkers(from);
    var toN = stripOutlineFoldMarkers(to);
    if (fromN === toN) {
        return '(unchanged)';
    }
    if (!fromN) {
        return "+".concat(formatDiffChunk(toN));
    }
    if (!toN) {
        return "-".concat(formatDiffChunk(fromN));
    }
    // Prefer line-oriented unique content when bodies look like outlines / multi-line notes
    if (fromN.includes('\n') || toN.includes('\n')) {
        var unique = uniqueBodyLinesPreview(fromN, toN);
        if (unique) {
            return unique;
        }
    }
    var a = tokenizeForDiff(fromN);
    var b = tokenizeForDiff(toN);
    if (a.length > TEXT_DIFF_TOKEN_LIMIT || b.length > TEXT_DIFF_TOKEN_LIMIT) {
        return summarizeTextDiffPrefixSuffix(fromN, toN);
    }
    return formatMultiHunkDiff(diffTokensLcs(a, b));
}
exports.summarizeTextDiff = summarizeTextDiff;
function formatFieldChangeSummary(fieldName, fromValue, toValue) {
    if (TEXT_DIFF_FIELDS.has(fieldName)) {
        var fromText = isMeaningfulDraftValue(fromValue) ? String(fromValue) : '';
        var toText = isMeaningfulDraftValue(toValue) ? String(toValue) : '';
        return summarizeTextDiff(fromText, toText);
    }
    if (fieldName === 'pnCustomTimeUTC' || fieldName === 'pnCompletedUTC') {
        return "".concat(formatDisplayValue(fieldName, fromValue), " \u2192 ").concat(formatDisplayValue(fieldName, toValue));
    }
    var fromDisplay = formatDisplayValue(fieldName, fromValue);
    var toDisplay = formatDisplayValue(fieldName, toValue);
    if (fromDisplay === toDisplay) {
        return '(changed)';
    }
    return "".concat(fromDisplay, " \u2192 ").concat(toDisplay);
}
exports.formatFieldChangeSummary = formatFieldChangeSummary;
function formatDisplayValue(fieldName, value) {
    if (!isMeaningfulDraftValue(value)) {
        return '(empty)';
    }
    if (fieldName === 'pnCustomTimeUTC' || fieldName === 'pnCompletedUTC') {
        var d = value instanceof Date ? value : new Date(value);
        return isNaN(d.getTime()) ? '(empty)' : d.toLocaleString();
    }
    if (fieldName === 'pnBody') {
        var text = String(value);
        return text.length > 40 ? "".concat(text.slice(0, 40), "\u2026") : text;
    }
    return String(value);
}
function isRiskyChange(field, mode, currentValue, draftValue) {
    var riskySet = mode === 'edit' ? exports.RISKY_EDIT_FIELDS : exports.RISKY_REPLY_FIELDS;
    if (!riskySet.has(field)) {
        return false;
    }
    var currentHas = isMeaningfulDraftValue(currentValue);
    var draftEmpty = !isMeaningfulDraftValue(draftValue);
    if (currentHas && draftEmpty) {
        return true;
    }
    if (currentHas && !valuesEqual(currentValue, draftValue, field)) {
        return true;
    }
    return false;
}
function summarizeDraftChanges(current, draftFields, mode) {
    var changes = [];
    getDraftFieldNames(mode).forEach(function (field) {
        var currentValue = current ? current[field] : undefined;
        var draftValue = draftFields[field];
        if (valuesEqual(currentValue, draftValue, field)) {
            return;
        }
        var risky = isRiskyChange(field, mode, currentValue, draftValue);
        changes.push({
            field: field,
            label: exports.FIELD_LABELS[field] || field,
            currentDisplay: formatDisplayValue(field, currentValue),
            draftDisplay: formatDisplayValue(field, draftValue),
            changeSummary: formatFieldChangeSummary(field, currentValue, draftValue),
            risky: risky,
        });
    });
    var riskyChanges = changes.filter(function (c) { return c.risky; });
    var hasRiskyChanges = riskyChanges.length > 0;
    var summaryText = '';
    if (changes.length === 0) {
        summaryText = 'Draft matches the current form.';
    }
    else {
        var names = changes.map(function (c) { return c.label; }).join(', ');
        var detailParts = changes.map(function (c) { return "".concat(c.label, ": ").concat(c.changeSummary); });
        summaryText = "Draft changes: ".concat(names, ". ").concat(detailParts.join('; '));
        if (hasRiskyChanges) {
            var riskyNames = riskyChanges.map(function (c) { return c.label; }).join(', ');
            summaryText += " Warning: may clear or change ".concat(riskyNames, ".");
        }
    }
    return {
        revisionCount: 0,
        latestSavedAt: null,
        changes: changes,
        hasRiskyChanges: hasRiskyChanges,
        summaryText: summaryText,
    };
}
exports.summarizeDraftChanges = summarizeDraftChanges;
function pruneExpiredRevisions(history, nowMs) {
    if (nowMs === void 0) { nowMs = Date.now(); }
    var revisions = history.revisions.filter(function (rev) {
        var savedAtMs = new Date(rev.savedAt).getTime();
        return isFinite(savedAtMs) && nowMs - savedAtMs <= exports.LOCAL_DRAFT_MAX_AGE_MS;
    });
    return __assign(__assign({}, history), { revisions: revisions });
}
function loadDraftHistory(storage, personId, mode, rowId) {
    var _a;
    var key = getLocalDraftStorageKey(personId, mode, rowId);
    var raw = storage.getItem(key);
    if (!raw) {
        return null;
    }
    try {
        var parsed = JSON.parse(raw);
        if (!((_a = parsed === null || parsed === void 0 ? void 0 : parsed.revisions) === null || _a === void 0 ? void 0 : _a.length)) {
            storage.removeItem(key);
            return null;
        }
        var pruned = pruneExpiredRevisions(parsed);
        if (!pruned.revisions.length) {
            storage.removeItem(key);
            return null;
        }
        if (pruned.revisions.length !== parsed.revisions.length) {
            storage.setItem(key, JSON.stringify(pruned));
        }
        return pruned;
    }
    catch (_b) {
        storage.removeItem(key);
        return null;
    }
}
exports.loadDraftHistory = loadDraftHistory;
function appendDraftRevision(history, fields, savedAt) {
    if (savedAt === void 0) { savedAt = new Date().toISOString(); }
    var latest = history.revisions[0];
    if (latest && revisionsEqual(latest.fields, fields, history.mode)) {
        return history;
    }
    var revisions = __spreadArray([{ savedAt: savedAt, fields: fields }], history.revisions, true);
    return __assign(__assign({}, history), { revisions: revisions.slice(0, exports.LOCAL_DRAFT_MAX_REVISIONS) });
}
exports.appendDraftRevision = appendDraftRevision;
function saveDraftHistory(storage, history) {
    var key = getLocalDraftStorageKey(history.personId, history.mode, history.rowId);
    if (!history.revisions.length) {
        storage.removeItem(key);
        return;
    }
    storage.setItem(key, JSON.stringify(history));
}
exports.saveDraftHistory = saveDraftHistory;
function clearDraftHistory(storage, personId, mode, rowId) {
    storage.removeItem(getLocalDraftStorageKey(personId, mode, rowId));
}
exports.clearDraftHistory = clearDraftHistory;
function getArchiveStorageKey(personId) {
    return "".concat(exports.LOCAL_DRAFT_ARCHIVE_PREFIX, ":").concat(personId !== null && personId !== void 0 ? personId : 'anon');
}
exports.getArchiveStorageKey = getArchiveStorageKey;
function generateArchiveId() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).slice(2, 10));
}
/**
 * Revision index whose content best represents what recover will apply / show in the list.
 * Prefer the latest revision (index 0) so the list reflects the final archived snapshot;
 * fall back through older revs only if latest is empty of body.
 */
function pickArchivePreviewRevisionIndex(history) {
    var _a, _b;
    if (!history.revisions.length) {
        return 0;
    }
    // Latest first — matches “what you last had before archive”
    for (var i = 0; i < history.revisions.length; i++) {
        var body = (_b = (_a = history.revisions[i]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.pnBody;
        if (typeof body === 'string' && body.trim().length > 0) {
            return i;
        }
    }
    return 0;
}
exports.pickArchivePreviewRevisionIndex = pickArchivePreviewRevisionIndex;
/** Fields recover() applies for this archive history. */
function getRecoverRevisionFields(history) {
    var _a, _b;
    var index = pickArchivePreviewRevisionIndex(history);
    return __assign({}, ((_b = (_a = history.revisions[index]) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : {}));
}
exports.getRecoverRevisionFields = getRecoverRevisionFields;
function bodyPreviewFromRevisionFields(fields, maxLines, maxChars) {
    if (maxLines === void 0) { maxLines = 6; }
    if (maxChars === void 0) { maxChars = 480; }
    var body = fields === null || fields === void 0 ? void 0 : fields.pnBody;
    if (!body || typeof body !== 'string') {
        return '(no body)';
    }
    var normalized = body.replace(/\r\n?/g, '\n').replace(/[ \t]+\n/g, '\n').trimEnd();
    if (!normalized.trim()) {
        return '(empty body)';
    }
    var lines = normalized.split('\n');
    var kept = lines.slice(0, maxLines);
    var text = kept.join('\n');
    if (lines.length > maxLines) {
        text += '\n…';
    }
    if (text.length > maxChars) {
        text = "".concat(text.slice(0, maxChars), "\u2026");
    }
    return text;
}
exports.bodyPreviewFromRevisionFields = bodyPreviewFromRevisionFields;
function bodyPreviewFromDraftHistory(history) {
    return bodyPreviewFromRevisionFields(getRecoverRevisionFields(history));
}
exports.bodyPreviewFromDraftHistory = bodyPreviewFromDraftHistory;
/** Normalize body text for line-oriented archive diffs. */
function normalizeBodyLines(value) {
    if (value == null || value === '') {
        return [];
    }
    return String(value)
        .replace(/\r\n?/g, '\n')
        .replace(/[ \t]*\(\+\)[ \t]*$/gm, '')
        .replace(/[ \t]+$/gm, '')
        .split('\n');
}
exports.normalizeBodyLines = normalizeBodyLines;
/**
 * Lines present only on one side (fold-insensitive multiset).
 * After reorders, LCS first-hunk is noisy; unique lines surface new/lost typing.
 */
function uniqueBodyLines(fromBody, toBody) {
    var a = normalizeBodyLines(fromBody);
    var b = normalizeBodyLines(toBody);
    var count = function (lines) {
        var m = new Map();
        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
            var line = lines_1[_i];
            var k = outlineLineContentKey(line);
            if (!k.trim())
                continue; // skip blank-only
            m.set(k, (m.get(k) || 0) + 1);
        }
        return m;
    };
    var ca = count(a);
    var cb = count(b);
    var onlyFrom = [];
    var onlyTo = [];
    // Preserve first-seen display form
    var seenFrom = new Set();
    var seenTo = new Set();
    for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
        var line = a_1[_i];
        var k = outlineLineContentKey(line);
        if (!k.trim() || seenFrom.has(k))
            continue;
        var da = ca.get(k) || 0;
        var db = cb.get(k) || 0;
        if (da > db) {
            onlyFrom.push(line);
            seenFrom.add(k);
        }
    }
    for (var _a = 0, b_1 = b; _a < b_1.length; _a++) {
        var line = b_1[_a];
        var k = outlineLineContentKey(line);
        if (!k.trim() || seenTo.has(k))
            continue;
        var da = ca.get(k) || 0;
        var db = cb.get(k) || 0;
        if (db > da) {
            onlyTo.push(line);
            seenTo.add(k);
        }
    }
    return { onlyFrom: onlyFrom, onlyTo: onlyTo };
}
exports.uniqueBodyLines = uniqueBodyLines;
/** Compact mono preview: only unique lines (best for reorder + new text). */
function uniqueBodyLinesPreview(fromBody, toBody, maxLines) {
    if (maxLines === void 0) { maxLines = 8; }
    var _a = uniqueBodyLines(fromBody, toBody), onlyFrom = _a.onlyFrom, onlyTo = _a.onlyTo;
    if (!onlyFrom.length && !onlyTo.length) {
        return null; // pure reorder / fold / blank changes
    }
    return bodyDiffViewLinesToMono(formatBodyDiffViewLines(onlyFrom, onlyTo, maxLines));
}
exports.uniqueBodyLinesPreview = uniqueBodyLinesPreview;
/**
 * Line LCS edit script. Caps size so archive UI stays snappy on large notes.
 * Falls back to a tiny first-change window if either side is huge.
 */
function lineEditScript(a, b) {
    var n = a.length;
    var m = b.length;
    if (n * m > 80000) {
        // Cheap path: first differing line only (+1 neighbor)
        var i_2 = 0;
        while (i_2 < n && i_2 < m && a[i_2] === b[i_2]) {
            i_2 += 1;
        }
        var edits_1 = [];
        if (i_2 < n) {
            edits_1.push({ kind: 'del', line: a[i_2], fromIndex: i_2, toIndex: Math.min(i_2, m) });
        }
        if (i_2 < m) {
            edits_1.push({ kind: 'add', line: b[i_2], fromIndex: Math.min(i_2, n), toIndex: i_2 });
        }
        return edits_1;
    }
    // DP LCS lengths
    var dp = new Array(n + 1);
    for (var i_3 = 0; i_3 <= n; i_3++) {
        dp[i_3] = new Uint16Array(m + 1);
    }
    for (var i_4 = n - 1; i_4 >= 0; i_4--) {
        for (var j_2 = m - 1; j_2 >= 0; j_2--) {
            if (a[i_4] === b[j_2]) {
                dp[i_4][j_2] = (dp[i_4 + 1][j_2 + 1] + 1);
            }
            else {
                dp[i_4][j_2] = Math.max(dp[i_4 + 1][j_2], dp[i_4][j_2 + 1]);
            }
        }
    }
    var edits = [];
    var i = 0;
    var j = 0;
    while (i < n && j < m) {
        if (a[i] === b[j]) {
            edits.push({ kind: 'eq', line: a[i], fromIndex: i, toIndex: j });
            i += 1;
            j += 1;
        }
        else if (dp[i + 1][j] >= dp[i][j + 1]) {
            edits.push({ kind: 'del', line: a[i], fromIndex: i, toIndex: j });
            i += 1;
        }
        else {
            edits.push({ kind: 'add', line: b[j], fromIndex: i, toIndex: j });
            j += 1;
        }
    }
    while (i < n) {
        edits.push({ kind: 'del', line: a[i], fromIndex: i, toIndex: j });
        i += 1;
    }
    while (j < m) {
        edits.push({ kind: 'add', line: b[j], fromIndex: i, toIndex: j });
        j += 1;
    }
    return edits;
}
/**
 * First real change hunk via line LCS (not prefix/suffix trim).
 * Compares fold-stripped lines; default context is 0 so unchanged lines do not dominate.
 */
function firstBodyLineDiffHunk(fromBody, toBody, contextLines, maxHunkLines) {
    var _a;
    if (contextLines === void 0) { contextLines = 0; }
    if (maxHunkLines === void 0) { maxHunkLines = 14; }
    var aRaw = normalizeBodyLines(fromBody);
    var bRaw = normalizeBodyLines(toBody);
    var a = aRaw.map(outlineLineContentKey);
    var b = bRaw.map(outlineLineContentKey);
    if (a.length === b.length && a.every(function (line, i) { return line === b[i]; })) {
        return null;
    }
    // LCS on content keys; display original (fold-stripped) text from raw arrays
    var edits = lineEditScript(a, b);
    // Map display lines: for each edit use raw line when indices valid
    var displayEdits = edits.map(function (e) {
        var _a, _b, _c;
        if (e.kind === 'eq') {
            return __assign(__assign({}, e), { line: (_a = aRaw[e.fromIndex]) !== null && _a !== void 0 ? _a : e.line });
        }
        if (e.kind === 'del') {
            return __assign(__assign({}, e), { line: (_b = aRaw[e.fromIndex]) !== null && _b !== void 0 ? _b : e.line });
        }
        return __assign(__assign({}, e), { line: (_c = bRaw[e.toIndex]) !== null && _c !== void 0 ? _c : e.line });
    });
    var firstChange = displayEdits.findIndex(function (e) { return e.kind !== 'eq'; });
    if (firstChange < 0) {
        return null;
    }
    var from = firstChange;
    var ctx = 0;
    while (from > 0 && ctx < contextLines && displayEdits[from - 1].kind === 'eq') {
        from -= 1;
        ctx += 1;
    }
    var to = firstChange;
    var eqRun = 0;
    while (to < displayEdits.length - 1) {
        var next = displayEdits[to + 1];
        if (next.kind !== 'eq') {
            to += 1;
            eqRun = 0;
            continue;
        }
        if (eqRun < 1 && to + 2 < displayEdits.length && displayEdits[to + 2].kind !== 'eq') {
            to += 1;
            eqRun += 1;
            continue;
        }
        break;
    }
    ctx = 0;
    while (to < displayEdits.length - 1 && ctx < contextLines && displayEdits[to + 1].kind === 'eq') {
        to += 1;
        ctx += 1;
    }
    var slice = displayEdits.slice(from, to + 1);
    var removed = 0;
    var added = 0;
    var lines = [];
    for (var _i = 0, slice_1 = slice; _i < slice_1.length; _i++) {
        var e = slice_1[_i];
        // Always show fold-stripped text; use −|/+| so markdown bullets stay readable
        var text = stripOutlineFoldMarkers(e.line);
        if (e.kind === 'eq') {
            // Never include unchanged lines in archive previews (they look like "no change")
            continue;
        }
        else if (e.kind === 'del') {
            lines.push("\u2212| ".concat(text));
            removed += 1;
        }
        else {
            lines.push("+| ".concat(text));
            added += 1;
        }
    }
    var display = lines;
    if (display.length > maxHunkLines) {
        display = __spreadArray(__spreadArray([], display.slice(0, maxHunkLines), true), [' …'], false);
    }
    var atLine = ((_a = displayEdits[firstChange].fromIndex) !== null && _a !== void 0 ? _a : 0) + 1;
    var headline = "line ".concat(atLine, ": \u2212").concat(removed, " +").concat(added);
    return { atLine: atLine, removed: removed, added: added, lines: display, headline: headline };
}
exports.firstBodyLineDiffHunk = firstBodyLineDiffHunk;
/** Multi-line preview of body differences (for archive list cards). */
function bodyDiffPreview(fromBody, toBody) {
    return bodyDiffViewLinesToMono(bodyDiffViewLines(fromBody, toBody, 12));
}
exports.bodyDiffPreview = bodyDiffPreview;
function summarizeFieldChanges(changes) {
    if (!changes.length) {
        return null;
    }
    var parts = changes.map(function (c) {
        if (c.field === 'pnBody') {
            // Prefer line-oriented headline over token soup for long notes
            var fromMatch = c.changeSummary;
            // Recompute from displays when possible — callers should pass structured hunks for body.
            var short_1 = displayDraftChangeSummary(fromMatch).replace(/\s+/g, ' ').trim();
            if (short_1.length > 80 && c.currentDisplay && c.draftDisplay) {
                // fallback compact
            }
            var clipped_1 = short_1.length > 120 ? "".concat(short_1.slice(0, 120), "\u2026") : short_1;
            return "".concat(c.label, ": ").concat(clipped_1);
        }
        var short = displayDraftChangeSummary(c.changeSummary).replace(/\s+/g, ' ').trim();
        var clipped = short.length > 100 ? "".concat(short.slice(0, 100), "\u2026") : short;
        return "".concat(c.label, ": ").concat(clipped);
    });
    return parts.join(' · ');
}
function summarizeBodyChangeHeadline(fromBody, toBody) {
    var _a = uniqueBodyLines(fromBody, toBody), onlyFrom = _a.onlyFrom, onlyTo = _a.onlyTo;
    if (onlyTo.length || onlyFrom.length) {
        var sample_1 = (onlyTo[0] || onlyFrom[0] || '').trim();
        var clipped_2 = sample_1.length > 50 ? "".concat(sample_1.slice(0, 50), "\u2026") : sample_1;
        return "body unique \u2212".concat(onlyFrom.length, " +").concat(onlyTo.length).concat(clipped_2 ? " \u00B7 ".concat(clipped_2) : '');
    }
    var hunk = firstBodyLineDiffHunk(fromBody, toBody, 0, 4);
    if (!hunk) {
        return 'body: identical (fold/reorder)';
    }
    var sample = hunk.lines.find(function (l) { return l.startsWith('+') && l.length > 1; }) ||
        hunk.lines.find(function (l) { return l.startsWith('-') && l.length > 1; }) ||
        '';
    var sampleText = sample.replace(/^[+-]/, '').trim();
    var clipped = sampleText.length > 60 ? "".concat(sampleText.slice(0, 60), "\u2026") : sampleText;
    return clipped ? "body ".concat(hunk.headline, " \u00B7 ").concat(clipped) : "body ".concat(hunk.headline);
}
function formMatchesRevisionFields(target, mode, revisionFields) {
    return revisionsEqual(collectDraftFields(target, mode), revisionFields, mode);
}
exports.formMatchesRevisionFields = formMatchesRevisionFields;
function toArchivedSummary(record) {
    var recoverFields = getRecoverRevisionFields(record.history);
    return {
        id: record.id,
        archivedAt: record.archivedAt,
        reason: record.reason,
        rowId: record.rowId,
        mode: record.mode,
        revisionCount: record.revisionCount,
        latestSavedAt: record.latestSavedAt,
        bodyPreview: bodyPreviewFromRevisionFields(recoverFields),
    };
}
/**
 * Build archive list for a row: newest first, multi-line previews, and diffs
 * vs open form + vs next-older archive (lineage).
 */
function listArchivedDraftSummaries(storage, personId, filter, currentForm) {
    var records = loadArchivedDrafts(storage, personId);
    if ((filter === null || filter === void 0 ? void 0 : filter.rowId) !== undefined) {
        records = records.filter(function (record) { return String(record.rowId) === String(filter.rowId); });
    }
    if (filter === null || filter === void 0 ? void 0 : filter.mode) {
        records = records.filter(function (record) { return record.mode === filter.mode; });
    }
    // Newest archive first (lineage top → older below)
    records = __spreadArray([], records, true).sort(function (a, b) {
        var ta = new Date(a.archivedAt).getTime();
        var tb = new Date(b.archivedAt).getTime();
        return (isFinite(tb) ? tb : 0) - (isFinite(ta) ? ta : 0);
    });
    var formFields = currentForm && (filter === null || filter === void 0 ? void 0 : filter.mode)
        ? collectDraftFields(currentForm, filter.mode)
        : currentForm && records[0]
            ? collectDraftFields(currentForm, records[0].mode)
            : null;
    return records.map(function (record, index) {
        var _a;
        var recoverFields = getRecoverRevisionFields(record.history);
        var mode = record.mode;
        var archiveBody = recoverFields.pnBody;
        var formBody = formFields === null || formFields === void 0 ? void 0 : formFields.pnBody;
        var summary = toArchivedSummary(record);
        if (formFields) {
            var vsForm = diffSerializedDraftFields(formFields, recoverFields, mode);
            summary.matchesForm = vsForm.length === 0;
            // Fold-insensitive body compare
            var bodyDiffers = !valuesEqual(formBody, archiveBody, 'pnBody');
            var bodyHeadline = bodyDiffers
                ? summarizeBodyChangeHeadline(formBody, archiveBody)
                : null;
            var otherChanges = vsForm.filter(function (c) { return c.field !== 'pnBody'; });
            var otherSummary = summarizeFieldChanges(otherChanges);
            if (summary.matchesForm) {
                summary.diffVsFormSummary = 'Same as open form';
            }
            else if (bodyHeadline && otherSummary) {
                summary.diffVsFormSummary = "".concat(bodyHeadline, " \u00B7 ").concat(otherSummary);
            }
            else if (bodyHeadline) {
                summary.diffVsFormSummary = bodyHeadline;
            }
            else {
                summary.diffVsFormSummary = otherSummary || 'Differs from open form';
            }
            if (bodyDiffers) {
                summary.bodyPreviewLines = bodyDiffViewLines(formBody, archiveBody, 12);
                summary.bodyPreview = bodyDiffViewLinesToMono(summary.bodyPreviewLines);
            }
            // Prefer unique-line body display in expanded field diffs
            summary.diffVsFormItems = toDraftChangeDisplayItems(vsForm).map(function (item) {
                if (item.field !== 'pnBody') {
                    return item;
                }
                var lines = bodyDiffViewLines(formBody, archiveBody, 12);
                return __assign(__assign({}, item), { displaySummary: bodyDiffViewLinesToMono(lines), diffKind: 'mixed' });
            });
        }
        var older = records[index + 1];
        if (older) {
            var olderFields = getRecoverRevisionFields(older.history);
            var olderBody_1 = olderFields.pnBody;
            var vsPrev = diffSerializedDraftFields(olderFields, recoverFields, mode);
            var bodyDiffersPrev = !valuesEqual(olderBody_1, archiveBody, 'pnBody');
            var bodyHeadline = bodyDiffersPrev
                ? summarizeBodyChangeHeadline(olderBody_1, archiveBody)
                : null;
            var otherChanges = vsPrev.filter(function (c) { return c.field !== 'pnBody'; });
            var otherSummary = summarizeFieldChanges(otherChanges);
            if (vsPrev.length === 0) {
                summary.diffVsPreviousSummary = 'Same as older archive below';
            }
            else if (bodyHeadline && otherSummary) {
                summary.diffVsPreviousSummary = "".concat(bodyHeadline, " \u00B7 ").concat(otherSummary);
            }
            else if (bodyHeadline) {
                summary.diffVsPreviousSummary = bodyHeadline;
            }
            else {
                summary.diffVsPreviousSummary = otherSummary || 'Differs from older archive';
            }
            summary.diffVsPreviousItems = toDraftChangeDisplayItems(vsPrev).map(function (item) {
                if (item.field !== 'pnBody') {
                    return item;
                }
                var lines = bodyDiffViewLines(olderBody_1, archiveBody, 12);
                return __assign(__assign({}, item), { displaySummary: bodyDiffViewLinesToMono(lines), diffKind: 'mixed' });
            });
            if (bodyDiffersPrev) {
                summary.bodyPreviewLinesVsPrevious = bodyDiffViewLines(olderBody_1, archiveBody, 12);
            }
        }
        else {
            summary.diffVsPreviousSummary = null;
            summary.diffVsPreviousItems = [];
        }
        // One primary body diff per card (not form + previous + field dumps all open).
        // Prefer vs open form (what recover does); else vs older archive; else short note.
        if (formFields && !summary.matchesForm) {
            if (!summary.bodyPreviewLines) {
                summary.bodyPreviewLines = bodyDiffViewLines(formBody, archiveBody, 12);
            }
            summary.bodyPreview = bodyDiffViewLinesToMono(summary.bodyPreviewLines);
            summary.bodyPreviewLabel = 'vs open form (recover applies this archive)';
        }
        else if (older && ((_a = summary.bodyPreviewLinesVsPrevious) === null || _a === void 0 ? void 0 : _a.length)) {
            summary.bodyPreviewLines = summary.bodyPreviewLinesVsPrevious;
            summary.bodyPreview = bodyDiffViewLinesToMono(summary.bodyPreviewLines);
            summary.bodyPreviewLabel = 'vs older archive below';
        }
        else if (summary.matchesForm) {
            summary.bodyPreview = '(same as open form — recover is a no-op)';
            summary.bodyPreviewLines = [
                { kind: 'meta', text: 'Same as open form — recover is a no-op', mono: '(same as open form)' },
            ];
            summary.bodyPreviewLabel = null;
        }
        else {
            summary.bodyPreview = bodyPreviewFromRevisionFields(recoverFields);
            summary.bodyPreviewLines = [
                { kind: 'meta', text: summary.bodyPreview, mono: summary.bodyPreview },
            ];
            summary.bodyPreviewLabel = null;
        }
        // Never auto-expand field-level dumps (duplicates the body preview)
        summary._diffOpen = false;
        return summary;
    });
}
exports.listArchivedDraftSummaries = listArchivedDraftSummaries;
function pruneArchivedDrafts(records, nowMs) {
    if (nowMs === void 0) { nowMs = Date.now(); }
    var fresh = records.filter(function (record) {
        var archivedAtMs = new Date(record.archivedAt).getTime();
        return isFinite(archivedAtMs) && nowMs - archivedAtMs <= exports.LOCAL_DRAFT_ARCHIVE_MAX_AGE_MS;
    });
    return fresh.slice(0, exports.LOCAL_DRAFT_ARCHIVE_MAX_ENTRIES);
}
exports.pruneArchivedDrafts = pruneArchivedDrafts;
function loadArchivedDrafts(storage, personId) {
    var raw = storage.getItem(getArchiveStorageKey(personId));
    if (!raw) {
        return [];
    }
    try {
        var parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            storage.removeItem(getArchiveStorageKey(personId));
            return [];
        }
        var pruned = pruneArchivedDrafts(parsed);
        if (pruned.length !== parsed.length) {
            storage.setItem(getArchiveStorageKey(personId), JSON.stringify(pruned));
        }
        return pruned;
    }
    catch (_a) {
        storage.removeItem(getArchiveStorageKey(personId));
        return [];
    }
}
exports.loadArchivedDrafts = loadArchivedDrafts;
function saveArchivedDrafts(storage, personId, records) {
    var pruned = pruneArchivedDrafts(records);
    if (!pruned.length) {
        storage.removeItem(getArchiveStorageKey(personId));
        return;
    }
    storage.setItem(getArchiveStorageKey(personId), JSON.stringify(pruned));
}
function countArchivedDrafts(storage, personId, filter) {
    return listArchivedDraftSummaries(storage, personId, filter).length;
}
exports.countArchivedDrafts = countArchivedDrafts;
function pushArchivedRecord(storage, personId, record) {
    var records = loadArchivedDrafts(storage, personId);
    records.unshift(record);
    saveArchivedDrafts(storage, personId, records);
}
function buildArchivedRecord(history, reason) {
    var _a;
    var latest = getLatestRevision(history);
    return {
        id: generateArchiveId(),
        archivedAt: new Date().toISOString(),
        reason: reason,
        personId: history.personId,
        rowId: history.rowId,
        mode: history.mode,
        revisionCount: history.revisions.length,
        latestSavedAt: (_a = latest === null || latest === void 0 ? void 0 : latest.savedAt) !== null && _a !== void 0 ? _a : null,
        bodyPreview: bodyPreviewFromDraftHistory(history),
        history: history,
    };
}
function draftFieldsDiffer(left, right, mode) {
    return getDraftFieldNames(mode).some(function (field) { return !valuesEqual(left[field], right[field], field); });
}
exports.draftFieldsDiffer = draftFieldsDiffer;
function findArchivedDraftRecord(storage, personId, archiveId) {
    var _a;
    return (_a = loadArchivedDrafts(storage, personId).find(function (record) { return record.id === archiveId; })) !== null && _a !== void 0 ? _a : null;
}
exports.findArchivedDraftRecord = findArchivedDraftRecord;
function hasDuplicateReplacedArchive(records, rowId, mode, fields) {
    return records.some(function (record) {
        var _a, _b;
        return record.reason === 'replaced' &&
            String(record.rowId) === String(rowId) &&
            record.mode === mode &&
            revisionsEqual((_b = (_a = record.history.revisions[0]) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : {}, fields, mode);
    });
}
/** Archive a single form snapshot (e.g. current editor content before recover). */
function archiveFormSnapshot(storage, personId, mode, rowId, fields, reason) {
    var records = loadArchivedDrafts(storage, personId);
    if (reason === 'replaced' && hasDuplicateReplacedArchive(records, rowId, mode, fields)) {
        return null;
    }
    var history = {
        mode: mode,
        rowId: rowId,
        personId: personId,
        revisions: [{ savedAt: new Date().toISOString(), fields: __assign({}, fields) }],
    };
    var record = buildArchivedRecord(history, reason);
    pushArchivedRecord(storage, personId, record);
    return record;
}
exports.archiveFormSnapshot = archiveFormSnapshot;
function archiveDraftHistory(storage, personId, mode, rowId, reason) {
    if (rowId === undefined || rowId === null) {
        return null;
    }
    var history = loadDraftHistory(storage, personId, mode, rowId);
    if (!(history === null || history === void 0 ? void 0 : history.revisions.length)) {
        return null;
    }
    var record = buildArchivedRecord(history, reason);
    pushArchivedRecord(storage, personId, record);
    clearDraftHistory(storage, personId, mode, rowId);
    return record;
}
exports.archiveDraftHistory = archiveDraftHistory;
function archiveAndClearDraftHistory(storage, personId, mode, rowId, reason) {
    return archiveDraftHistory(storage, personId, mode, rowId, reason);
}
exports.archiveAndClearDraftHistory = archiveAndClearDraftHistory;
function restoreArchivedDraftToActive(storage, personId, archiveId) {
    var records = loadArchivedDrafts(storage, personId);
    var index = records.findIndex(function (record) { return record.id === archiveId; });
    if (index < 0) {
        return null;
    }
    var record = records.splice(index, 1)[0];
    saveArchivedDrafts(storage, personId, records);
    var active = loadDraftHistory(storage, personId, record.mode, record.rowId);
    if (active === null || active === void 0 ? void 0 : active.revisions.length) {
        archiveDraftHistory(storage, personId, record.mode, record.rowId, 'cleared');
    }
    saveDraftHistory(storage, record.history);
    return record.history;
}
exports.restoreArchivedDraftToActive = restoreArchivedDraftToActive;
/** Archive current form content when it differs from the revision about to be recovered. */
function archiveCurrentFormBeforeRecover(storage, personId, mode, rowId, currentFields, recoverRevisionFields) {
    if (!revisionsEqual(currentFields, recoverRevisionFields, mode)) {
        return archiveFormSnapshot(storage, personId, mode, rowId, currentFields, 'replaced');
    }
    return null;
}
exports.archiveCurrentFormBeforeRecover = archiveCurrentFormBeforeRecover;
function discardArchivedDraft(storage, personId, archiveId) {
    var records = loadArchivedDrafts(storage, personId);
    var next = records.filter(function (record) { return record.id !== archiveId; });
    if (next.length === records.length) {
        return false;
    }
    saveArchivedDrafts(storage, personId, next);
    return true;
}
exports.discardArchivedDraft = discardArchivedDraft;
function getLatestRevision(history) {
    var _a;
    return (_a = history.revisions[0]) !== null && _a !== void 0 ? _a : null;
}
exports.getLatestRevision = getLatestRevision;
function buildRestorePreview(history, current, revisionIndex) {
    var index = revisionIndex !== null && revisionIndex !== void 0 ? revisionIndex : findRestoreRevisionIndex(history, current);
    var revision = history.revisions[index];
    if (!revision) {
        return null;
    }
    var preview = summarizeDraftChanges(current, revision.fields, history.mode);
    preview.revisionCount = history.revisions.length;
    preview.latestSavedAt = revision.savedAt;
    return preview;
}
exports.buildRestorePreview = buildRestorePreview;
function captureUndoSnapshot(target, mode, savedAt) {
    var _a, _b, _c;
    if (savedAt === void 0) { savedAt = (_a = target._localDraftSavedAt) !== null && _a !== void 0 ? _a : null; }
    return {
        fields: collectDraftFields(target, mode),
        savedAt: (_c = (_b = savedAt === null || savedAt === void 0 ? void 0 : savedAt.toISOString) === null || _b === void 0 ? void 0 : _b.call(savedAt)) !== null && _c !== void 0 ? _c : null,
    };
}
exports.captureUndoSnapshot = captureUndoSnapshot;
function applyUndoSnapshot(target, snapshot, mode) {
    applyDraftFields(target, snapshot.fields);
    target._localDraftSavedAt = snapshot.savedAt ? new Date(snapshot.savedAt) : null;
}
exports.applyUndoSnapshot = applyUndoSnapshot;
